import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { InitialData } from 'app/app.types';
import { compactNavigation, defaultNavigation, futuristicNavigation, horizontalNavigation, defaultNavigationAdmin, defaultNavigationMedico,
    defaultNavigationAuxiliar } from 'app/data/navigation';
import { cloneDeep } from 'lodash-es';
import { Observable, of, Subscriber, Subscription } from 'rxjs';
import { UserService } from '../user/user.service';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {

    private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation;
    private _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
    private readonly _futuristicNavigation: FuseNavigationItem[] = futuristicNavigation;
    private readonly _horizontalNavigation: FuseNavigationItem[] = horizontalNavigation;



    /**
     * Constructor
     */
     constructor(
         private _userService: UserService
      )
     {
        //  this.listenUser();
         // Register Mock API handlers
         // this.registerHandlers();
     }

    /**
     * Register Mock API handlers
     */
     registerHandlers( role = 'ND'): Observable<any>
     {


        this._defaultNavigation = [];
        if ( role === 'ND') {
            this._defaultNavigation = [];
        }else if ( role === 'ROLE_ADMIN' ) {
            this._defaultNavigation = defaultNavigationAdmin;

        }else if ( role === 'ROLE_NUTRIOLOGO' ) {
            this._defaultNavigation = defaultNavigationMedico;

        }else if ( role === 'ROL_PACIENTE' ) {
            this._defaultNavigation =  [];

        }else if ( role === 'ROLE_ADMIN_AUXILIAR' ) {
            this._defaultNavigation = defaultNavigationAuxiliar;

        }

        // Fill compact navigation children using the default navigation
        this._compactNavigation.forEach((compactNavItem) => {
            this._defaultNavigation.forEach((defaultNavItem) => {
                if ( defaultNavItem.id === compactNavItem.id )
                {
                    compactNavItem.children = cloneDeep(defaultNavItem.children);
                }
            });
        });

        // Fill futuristic navigation children using the default navigation
        this._futuristicNavigation.forEach((futuristicNavItem) => {
            this._defaultNavigation.forEach((defaultNavItem) => {
                if ( defaultNavItem.id === futuristicNavItem.id )
                {
                    futuristicNavItem.children = cloneDeep(defaultNavItem.children);
                }
            });
        });

        // Fill horizontal navigation children using the default navigation
        this._horizontalNavigation.forEach((horizontalNavItem) => {
            this._defaultNavigation.forEach((defaultNavItem) => {
                if ( defaultNavItem.id === horizontalNavItem.id )
                {
                    horizontalNavItem.children = cloneDeep(defaultNavItem.children);
                }
            });
        });

        // Return the response
        return  of({
                compact   : cloneDeep(this._compactNavigation),
                default   : cloneDeep(this._defaultNavigation),
                futuristic: cloneDeep(this._futuristicNavigation),
                horizontal: cloneDeep(this._horizontalNavigation)
            });




     }



     registerHandlersFijo( role = 'ND'): any
     {


        this._defaultNavigation = [];
        if ( role === 'ND') {
            this._defaultNavigation = [];
        }else if ( role === 'ROLE_ADMIN' ) {
            this._defaultNavigation = defaultNavigationAdmin;

        }else if ( role === 'ROLE_NUTRIOLOGO' ) {
            this._defaultNavigation = defaultNavigationMedico;

        }else if ( role === 'ROL_PACIENTE' ) {
            this._defaultNavigation =  [];

        }else if ( role === 'ROLE_ADMIN_AUXILIAR' ) {
            this._defaultNavigation = defaultNavigationAuxiliar;
        }


        // Fill compact navigation children using the default navigation
        this._compactNavigation.forEach((compactNavItem) => {
            this._defaultNavigation.forEach((defaultNavItem) => {
                if ( defaultNavItem.id === compactNavItem.id )
                {
                    compactNavItem.children = cloneDeep(defaultNavItem.children);
                }
            });
        });

        // Fill futuristic navigation children using the default navigation
        this._futuristicNavigation.forEach((futuristicNavItem) => {
            this._defaultNavigation.forEach((defaultNavItem) => {
                if ( defaultNavItem.id === futuristicNavItem.id )
                {
                    futuristicNavItem.children = cloneDeep(defaultNavItem.children);
                }
            });
        });

        // Fill horizontal navigation children using the default navigation
        this._horizontalNavigation.forEach((horizontalNavItem) => {
            this._defaultNavigation.forEach((defaultNavItem) => {
                if ( defaultNavItem.id === horizontalNavItem.id )
                {
                    horizontalNavItem.children = cloneDeep(defaultNavItem.children);
                }
            });
        });

        // Return the response
        return  {
            compact   : cloneDeep(this._compactNavigation),
            default   : cloneDeep(this._defaultNavigation),
            futuristic: cloneDeep(this._futuristicNavigation),
            horizontal: cloneDeep(this._horizontalNavigation)
        };




     }

}
